var _excluded = ["property"];
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { NbnCardGraphQL } from '../nbn-card';
import { Features } from '.';
import { PrimaryFeaturePropTypes } from './primary-feature';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment ListingFeatures on Property {\n    listing {\n      primaryFeatures {\n        title\n        description\n      }\n      secondaryFeatures\n    }\n    ...NbnCard\n  }\n  ", "\n"])), NbnCardGraphQL.fragment);
export var FeaturesGraphQL = _ref => {
  var property = _ref.property,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX(Features, _extends({
    property: property,
    primaryFeatures: property.listing.primaryFeatures,
    secondaryFeatures: property.listing.secondaryFeatures
  }, otherProps));
};
FeaturesGraphQL.fragment = fragment;
FeaturesGraphQL.propTypes = {
  property: PropTypes.shape({
    listing: PropTypes.shape({
      primaryFeatures: PropTypes.arrayOf(PrimaryFeaturePropTypes),
      secondaryFeatures: PropTypes.arrayOf(PropTypes.string)
    })
  })
};
FeaturesGraphQL.defaultProps = {
  property: {}
};